<template>
  <div :class="rootClasses">
    <label v-if="$slots.label" :for="$attrs.id as string">
      <slot name="label" />
    </label>

    <slot v-if="$slots.startAdornment" name="startAdornment" />

    <PVInputText
      v-model="value"
      v-bind="$attrs"
      :placeholder="placeholder"
      @focus="focused = true"
      @blur="focused = false"
      @mouseover="hovered = true"
      @mouseleave="hovered = false"
      ref="input"
    />

    <slot v-if="$slots.endAdornment" name="endAdornment" />

    <span v-if="$slots.helperText" class="caption">
      <slot name="helperText" />
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed, useAttrs, useSlots, ref } from 'vue';
import type { VNode } from 'vue';
import PVInputText from 'primevue/inputtext';
import { useInputState } from '../composables';
import { useFocus } from '@vueuse/core';

defineSlots<{
  label(): VNode[];
  startAdornment(): VNode[];
  endAdornment(): VNode[];
  helperText(): VNode[];
}>();

const props = defineProps({
  placeholder: String,
  autofocus: {
    type: Boolean,
    default: false,
  },
});

const attrs = useAttrs();
const slots = useSlots();

const value = defineModel<any>();

const { focused, hovered, classes } = useInputState(attrs);

const rootClasses = computed(() => [
  ...classes.value,
  {
    'p-input-icon-left': slots.startAdornment,
    'p-input-icon-right': slots.endAdornment,
  },
]);

const input = ref();
useFocus(input, { initialValue: props.autofocus });

defineExpose({
  value,
});
</script>

<script lang="ts">
export default {
  name: 'InputText',
  inheritAttrs: false,
};
</script>
